export default {
  state: {
    loading: false,
    error: null,
    routingLink: null
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setRoutingLink (state, payload) {
      state.routingLink = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    }
  },
  actions: {
    clearError ({commit}) {
      commit('clearError')
    },
    setError ({commit}, payload) {
      commit('setError', payload)
    },
    setLoading ({commit}, payload) {
      commit('setLoading', payload)
    },
    setRoutingLink ({commit}, payload) {
      commit('setRoutingLink', payload)
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    routingLink (state) {
      return state.routingLink
    }
  }
}
